import { useState } from 'react';

// Shows the customer's Google photo when available, else branded initials
export const CustomerAvatar = ({ customer, size = 'w-9 h-9', textSize = 'text-sm', className = '', testId = 'customer-avatar' }) => {
  const [imgFailed, setImgFailed] = useState(false);
  const initial = (customer?.name || customer?.email || '?').trim().charAt(0).toUpperCase();

  if (customer?.picture && !imgFailed) {
    return (
      <img
        src={customer.picture}
        alt={customer.name || 'Profile'}
        referrerPolicy="no-referrer"
        onError={() => setImgFailed(true)}
        className={`${size} rounded-full object-cover flex-shrink-0 ${className}`}
        data-testid={testId}
      />
    );
  }
  return (
    <div
      className={`${size} rounded-full bg-[#E02128]/15 text-[#E02128] flex items-center justify-center ${textSize} font-semibold flex-shrink-0 ${className}`}
      data-testid={testId}
    >
      {initial}
    </div>
  );
};
